import moment from "moment";
import { any, func, bool, object, arrayOf, shape, string } from "prop-types";
import React, { useState, useEffect, Fragment } from "react";
import { connect } from "react-redux";

import * as style from "./styles.module.scss";
import OnboardingListItem from "../OnboardingListItem/OnboardingListItem";

import ReadingStatus from "../ReadingListDownload/reading_status";
import {
  markDocumentReadRegatta,
  updateUserInProfileSilent,
} from "../../redux/actions";

import {
  getPusterlaReadingPDF, // <-- for the declaration reading list PDFs` : '' }
} from "../../api/profileApi";

import OnboardingArea from "../../common/OnboardingSectionCreator";
import {
  triggerDownload,
  filenameFromUrl,
} from "../../common/OnboardingSectionCreator/helpers";
import { forceDownload } from "../../containers/ResourceFolders/util";

const RegattaOnboarding = ({
  appData,
  readingList,
  markDocumentRead,
  regattaReadingLoading,
  regattaAssessmentLoading,
}) => {
  const { regattaOnboarding } = { ...{ regattaOnboarding: {} }, ...appData };

  const [loading, setLoading] = useState(false);
  // const [loading, setLoading] = useState(false);
  const [curTypeCode, setCurTypeCode] = useState("");

  const getReadingPDF = () => {
    getPusterlaReadingPDF().then((response) => {
      forceDownload(response, "Regatta Policy File");
    });
  };

  const submitted = false;

  useEffect(() => {
    setLoading(false);
  }, [submitted]);

  const testResults =
    appData.regattaOnboarding &&
    appData.regattaOnboarding.literacyTestResultsRegatta;

  const isFormCompleted = (typeCode) =>
    !!(appData.regattaOnboarding && appData.regattaOnboarding[typeCode]);

  const testSubmitted = testResults && isFormCompleted("YRG4");

  const assessmentWithStatus = {
    status: isFormCompleted("YRG4") ? 3 : 1,
    title: "Numeracy and Literacy Test",
    text: "Complete",
    url: "regatta-onboarding/literacy-assessment",
    downloadingDisabled: true,
    loading: regattaAssessmentLoading,
    submitted: testSubmitted,
    disabled: regattaAssessmentLoading,
  };

  const assessmentScore = () =>
    Object.values(testResults).reduce((a, b) => a + b.correctAnswered, 0);

  const assessmentScorePercentage = () =>
    Math.floor((assessmentScore() / 50) * 100);

  const readDocuments =
    (regattaOnboarding && regattaOnboarding.readDocuments) || [];

  const readings = (regattaOnboarding && regattaOnboarding.readings) || [];

  const noCheckBoxConsentFiles = {
    // files for which no download will be shown after candidate has agreed
    // N/A for Regatta
  };

  const agreementTextValues = {
    // custom agreement text
    "Diversity & Inclusion":
      "I have read and understood the Diversity & Inclusion Policy",
    "Code of Conduct": "I have read and understood the Code of Conduct",
    "Health & Safety Induction":
      "I have read and understood the Health & Safety Induction.",
    "Management of Lockers":
      "I understand the locker key remains the property of Regatta Ltd at all times and that if I lose or damage any key I will be required to pay £7 per key for the cost of a replacement. I authorise Regatta Ltd to deduct the appropriate amount from my salary. I understand that a spare key, which will be kept securely, and that Regatta Ltd reserves the right to inspect/search the contents of the locker, in line with the company's search policy.",
    "Smart Device Policy":
      "I have read and understood the Smart Device Policy.",
    "Net 2 Swipe Card Procedure":
      "I have read and fully understand my responsibilities regarding using the access control system, Net 2.I also understand that non-compliance of the Health & Safety Brief may result in the enforcement of disciplinary procedures and also the non payment of overtime.",
    "Drug and Alcohol Policy":
      "I have read and understood the Drug & Alcohol Policy.",
    "Regatta Values Framework":
      "I have read and understood the Regatta Group Values Framework",
    "Data Protection Policy":
      "I have read and understood the Data Protection Policy",
  };

  const onFlyPDFs = ["Management of Lockers", "Net 2 Swipe Card Procedure"];

  const [currentlyReading, setCurrentlyReading] = useState(null);

  const readingListWithStatus = readingList.map((download) => {
    return {
      ...download,
      noCheckBoxConsent: noCheckBoxConsentFiles[download.title] || false,
      agreementText: agreementTextValues[download.title] || "",
      onFly: onFlyPDFs.includes(download.title),
      status:
        readDocuments.includes(filenameFromUrl(download.link)) ||
        Object.keys(readings).includes(filenameFromUrl(download.link))
          ? ReadingStatus.Done
          : ReadingStatus.Todo,
    };
  });

  const medicalQuestionnaire = [
    {
      status: regattaOnboarding.MedicalQuestionnaire
        ? ReadingStatus.Done
        : ReadingStatus.Todo,
      submitted: regattaOnboarding.YREG,
      title: "Questionnaire",
      loading: loading && curTypeCode === "YREG",
      url: `/profile/edit/regatta-onboarding/medical-questionnaire`,
      handleClick: regattaOnboarding.YREG
        ? () =>
            triggerDownload(
              "YREG",
              "Medical Questionnaire.pdf",
              setCurTypeCode,
              setLoading
            )
        : null,
    },
  ];

  const videosObj = [
    {
      title: "Opening of PP Regatta",
      url: "https://youtu.be/5WgVE7ivzDA",
    },
    {
      title: "Regatta AW19",
      url: "https://youtu.be/AM_TpO3uCnQ",
    },
    {
      title: "Crags Ambassador and Partnerships",
      url: "https://youtu.be/KSEWb9kyEwA",
    },
    {
      title: "DARE2BE",
      url: "https://youtu.be/BZVL0cvR3hk",
    },
  ];

  const weekReviewForms = [
    {
      status: isFormCompleted("YRG5") ? 3 : 1,
      name: "oneWeekReview",
      title: "1 Week Agency Review",
      text: "Complete",
      url: "regatta-onboarding/one-week-review",
      downloadingDisabled: true,
    },
    ...(isFormCompleted("YRG5")
      ? [
          {
            status: isFormCompleted("YRG6") ? 3 : 1,
            name: "sixWeekReview",
            title: "6 Week Agency Review",
            text: "Complete",
            url: "regatta-onboarding/six-week-review",
            downloadingDisabled: true,
          },
        ]
      : []),
    ...(isFormCompleted("YRG6")
      ? [
          {
            status: isFormCompleted("YRG7") ? 3 : 1,
            name: "twelveWeekReview",
            title: "12 Week Agency Review",
            text: "Complete",
            url: "regatta-onboarding/twelve-week-review",
            downloadingDisabled: true,
          },
        ]
      : []),
  ];

  const Video = ({ title, url }) => (
    <div className={`${style.videoContainer}`}>
      <p style={{ paddingTop: "15px" }}> {title} </p>
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <a
          className="btn btn-primary"
          style={{ alignSelf: "flex-end", justifySelf: "flex-end" }}
          href={`${url}`}
          target="_blank"
          rel="noreferrer"
        >
          Open Video
        </a>
      </div>
    </div>
  );

  const { ReturnToWork } = appData.regattaOnboarding;

  const ReturnToWorkComp = () => (
    <div>
      <OnboardingListItem
        title="Form"
        key="ReturnToWork"
        btnText="Complete"
        url={`/profile/edit/regatta-onboarding/return-to-work`}
        loading={false}
        downloadingDisabled={true}
      />
      {ReturnToWork && (
        <div className="pb-1">
          <h6 style={{ margin: "1rem 0 0.5rem 1rem" }}>Latest submissions:</h6>
          <ul style={{ margin: "0 1rem 1rem 0" }}>
            {Object.keys(ReturnToWork)
              .sort((a, b) => b.localeCompare(a))
              .map((el, i) => (
                <li style={{ fontSize: "13px" }} key={i}>
                  {moment(el).format("DD/MM/YYYY, HH:mm")}{" "}
                </li>
              ))}
          </ul>
        </div>
      )}
    </div>
  );

  const LiteracyTestComp = () => (
    <div>
      <OnboardingListItem
        title={assessmentWithStatus.title}
        status={assessmentWithStatus.status}
        btnText={assessmentWithStatus.text}
        key={assessmentWithStatus.title}
        url={assessmentWithStatus.url}
        downloadingDisabled={assessmentWithStatus.downloadingDisabled}
        loading={assessmentWithStatus.loading}
      />
      {testSubmitted && (
        <div className="section-body bg-white py-2 my-1 mt-lg-0">
          <h5 className="px-1">Test Results</h5>
          {Object.values(testResults).map((result) => (
            <div
              key={result.sectionNumber}
              style={{
                display: "flex",
                padding: "0 1rem",
                justifyContent: "space-between",
              }}
            >
              <p>Section {result.sectionNumber}</p>
              <p>
                {result.correctAnswered}/{result.numberOfQuestions}
              </p>
            </div>
          ))}
          <div
            style={{
              display: "flex",
              padding: "0 1rem",
              justifyContent: "space-between",
            }}
          >
            <p>
              <b>SCORE</b>
            </p>
            <p>
              <b>
                {assessmentScore()}/50 = {assessmentScorePercentage()}%
              </b>
            </p>
          </div>
          <p
            style={{
              padding: "0 1rem",
            }}
          >
            The pass rate for this test is 70% - 35 correct questions out of 50.
          </p>
        </div>
      )}
    </div>
  );

  const videos = () => (
    <div style={{ marginBottom: "20px" }}>
      {videosObj.map((v) => (
        <Video key={v.url} title={v.title} url={v.url} />
      ))}
    </div>
  );

  const leftColumnComponents = [
    // TODO allow blocks do this as <Array <Array>> so each index is a block with the below object [13/05/22]
    {
      title: "Policies",
      subtext:
        "You are required to download and read each policy before you start work.  For each policy you will be asked to tick the box to confirm you have read an understood and agree to it.  If you have any queries, please speak to your line manager.",
      formsListWithStatus: [],
      readingListWithStatus,
      currentlyReading,
      setCurrentlyReading,
      markDocumentRead,
      isLoading: regattaReadingLoading,
    },
    {
      title: `Induction Materials`,
      subtext:
        "Please click on the links below to watch these 4 videos to learn more about working at Regatta.",
      customComp: videos(),
      lastInColumn: true,
    },
  ];

  const rightColumnComponents = [
    {
      title: `Test`,
      subtext:
        "Please complete the test below. If you have any queries about the test, please speak to your HRGO Consultant.",
      customComp: <LiteracyTestComp />,
    },
    {
      title: `Medical Questionnaire`,
      subtext: `Please complete the questionnaire below. If you have any queries about the questionnaire, please speak to your line manager.`,
      formsListWithStatus: medicalQuestionnaire,
      fileUpload:
        appData.regattaOnboarding &&
        appData.regattaOnboarding.MedicalQuestionnaire &&
        appData.regattaOnboarding.MedicalQuestionnaire.MedicalQuestionnaire30,
      imageFileKey: "regattaMedicalPhoto",
      fileUploadDesc:
        'You have ticked the following field in the Medical Questionnaire: "Do you regularly take or are currently taking any medications?". Please attach a copy of the leaflet that accompanies the medication by taking a photo and uploading via the button below.',
      fileUploadTitle: "Medication Photo",
      fileUploadCond:
        (appData.regattaOnboarding &&
          appData.regattaOnboarding.regattaMedicalPhoto) ||
        false,
      lastInColumn: true,
    },
    {
      title: `Week Review Forms`,
      subtext: `Please complete the form below. If you have any queries about the form, please speak to your line manager.`,
      formsListWithStatus: weekReviewForms,
      lastInColumn: true,
    },
    {
      title: `Return To Work`,
      subtext:
        "If you need to complete a Return to Work form, please complete using the form below.",
      customComp: <ReturnToWorkComp />,
      lastInColumn: true,
    },
  ];

  return (
    <Fragment>
      <OnboardingArea
        title="Regatta Onboarding"
        leftColumnComponents={leftColumnComponents}
        rightColumnComponents={rightColumnComponents}
        leftSubmit={() => {}}
        hasDBS={false}
        markDocumentRead={markDocumentRead}
        getReadingPDF={getReadingPDF}
        isLoading={regattaReadingLoading}
      />
    </Fragment>
  );
};

RegattaOnboarding.propTypes = {
  appData: any,
  readingList: arrayOf(
    shape({
      title: string.isRequired,
      link: string.isRequired,
    })
  ),
  markDocumentRead: func.isRequired,
  regattaReadingLoading: bool,
  regattaOnboarding: object,
  regattaAssessmentLoading: bool,
};

const mapStateToProps = (state) => ({
  appData: state.core.app,
  regattaOnboarding: state.core.app.regattaOnboarding,
  readingList: state.core.umbracoContent.regattaReadingList,
  regattaReadingLoading: state.core.regattaReading.isLoading,
  regattaAssessmentLoading: state.core.regattaAssessment.isLoading,
});

const mapDispatchToProps = {
  markDocumentRead: markDocumentReadRegatta,
  updateProfile: updateUserInProfileSilent,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(RegattaOnboarding);
